/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BootstrapTenantAdminRequest
 */
export interface BootstrapTenantAdminRequest {
    /**
     * Bootstrap mode
     * @type {string}
     * @memberof BootstrapTenantAdminRequest
     */
    mode: BootstrapTenantAdminRequestModeEnum;
    /**
     * Admin email when mode='specific_email'
     * @type {string}
     * @memberof BootstrapTenantAdminRequest
     */
    adminEmail?: string;
    /**
     * Generate an initial password for local user creation
     * @type {boolean}
     * @memberof BootstrapTenantAdminRequest
     */
    generatePassword?: boolean;
    /**
     * Force password reset on first login (if supported)
     * @type {boolean}
     * @memberof BootstrapTenantAdminRequest
     */
    forcePasswordReset?: boolean;
}


/**
 * @export
 */
export const BootstrapTenantAdminRequestModeEnum = {
    CustomerPrimary: 'customer_primary',
    SpecificEmail: 'specific_email',
    DerivedBreakGlass: 'derived_break_glass'
} as const;
export type BootstrapTenantAdminRequestModeEnum = typeof BootstrapTenantAdminRequestModeEnum[keyof typeof BootstrapTenantAdminRequestModeEnum];


/**
 * Check if a given object implements the BootstrapTenantAdminRequest interface.
 */
export function instanceOfBootstrapTenantAdminRequest(value: object): value is BootstrapTenantAdminRequest {
    if (!('mode' in value) || value['mode'] === undefined) return false;
    return true;
}

export function BootstrapTenantAdminRequestFromJSON(json: any): BootstrapTenantAdminRequest {
    return BootstrapTenantAdminRequestFromJSONTyped(json, false);
}

export function BootstrapTenantAdminRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BootstrapTenantAdminRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mode': json['mode'],
        'adminEmail': json['adminEmail'] == null ? undefined : json['adminEmail'],
        'generatePassword': json['generatePassword'] == null ? undefined : json['generatePassword'],
        'forcePasswordReset': json['forcePasswordReset'] == null ? undefined : json['forcePasswordReset'],
    };
}

export function BootstrapTenantAdminRequestToJSON(json: any): BootstrapTenantAdminRequest {
    return BootstrapTenantAdminRequestToJSONTyped(json, false);
}

export function BootstrapTenantAdminRequestToJSONTyped(value?: BootstrapTenantAdminRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mode': value['mode'],
        'adminEmail': value['adminEmail'],
        'generatePassword': value['generatePassword'],
        'forcePasswordReset': value['forcePasswordReset'],
    };
}

